// Module
var code = `<breadcrumbs></breadcrumbs>
<section class="box">
  <sub-header header="'Red Flag Disposition'"></sub-header>
  <report-filters config="\$ctrl.filterConfig" params="\$ctrl.params"></report-filters>

  <div class="report-table-wrapper">
    <table class="table table--wide table--report">
      <tbody>
      <tr>
        <th>Branch</th>
        <th>Date</th>
        <th>Time</th>
        <th>CIF Number</th>
        <th>CIF Type</th>
        <th>Customer Name</th>
        <th>Account Number</th>
        <th>Account Name</th>
        <th>Operation Type</th>
        <th>Expected transaction count</th>
        <th>Actual transaction count</th>
        <th>Transaction Amount</th>
        <th>Posted by</th>
        <th>Approved by</th>
        <th>Source of funds</th>
        <th>Nature of Business/Occupation of work</th>
        <th>Reason for tagging</th>
        <th>Disposition</th>
        <th>Remarks</th>
        <th>Action</th>
      </tr>
      <tr ng-repeat="item in \$ctrl.data">
        <td>{{item.branch}}</td>
        <td>{{item.date}}</td>
        <td>{{item.time}}</td>
        <td>{{item.cifNumber}}</td>
        <td>{{item.cifType}}</td>
        <td>{{item.customerName}}</td>
        <td>{{item.accountNumber}}</td>
        <td>{{item.accountName}}</td>
        <td>{{\$ctrl.translateOperation(item.operationType)}}</td>
        <td>{{item.expectedTransactionCount}}</td>
        <td>{{item.actualTransactionCount}}</td>
        <td>{{item.transactionAmount | nxCurrency}}</td>
        <td>{{item.postedBy}}</td>
        <td>{{item.approvedBy}}</td>
        <td>{{item.sourceOfFunds}}</td>
        <td>{{item.sourceOfIncome}}</td>
        <td>{{item.taggingReason}}</td>
        <td>{{item.disposition | prettyEnum}}</td>
        <td>{{item.remarks}}</td>
        <td>
          <button
            command-access="UpdateRedFlagDisposition"
            type="button"
            class="btn btn-warning"
            ng-click="\$ctrl.displayModal(item)">
            Edit
          </button>
        </td>
      </tr>
      </tbody>
    </table>
  </div>

</section>

<modal on-api-ready="\$ctrl.onModalReady">
  <modal-header>
    <h2>Update disposition</h2>
  </modal-header>

  <modal-body>
    <ng-form name="\$ctrl.modalForm">
      <form-section>
        <form-section-field field-title="'Disposition'">
          <select
            ng-model="\$ctrl.modalInput.disposition"
            required
            ng-options="o.value as o.label for o in \$ctrl.dispositionOptions">
          </select>
        </form-section-field>
        <form-section-field field-title="'Remarks'">
        <textarea
          ng-model="\$ctrl.modalInput.remarks"
          rows="4"
          title="Remarks">
        </textarea>
        </form-section-field>
      </form-section>
    </ng-form>
  </modal-body>

  <modal-footer>
    <button type="button" ng-click="\$ctrl.updateDispositionModal.onCancel()" class="btn">Cancel</button>
    <button type="submit" ng-click="\$ctrl.updateDispositionModal.onOk()" ng-disabled="!\$ctrl.modalForm.\$valid" class="btn btn-primary">Submit</button>
  </modal-footer>
</modal>
`;
// Exports
var _module_exports = code;;
var path = 'src/app/components/administration/compliance/red-flag-disposition/red-flag-disposition.template.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;